export enum Theme {
  Light = 'light',
  Dark = 'dark'
}

export enum AuthenticationStatus {
  Unknown = 0,
  Unauthorized = 1,
  Authorized = 2
}

export enum LoadingState {
  Unknown = 0,
  NotLoaded = 1,
  Loading = 2,
  Loaded = 3
}

export enum Platform {
  Android = 'android',
  iOS = 'ios'
}

export enum Currency {
  USDT = 'usdt',
  IRT = 'irt'
}

export enum DealMode {
  Buy = 'buy',
  Sell = 'sell'
}

export enum DealType {
  P2P = 'p2p',
  OTC = 'otc'
}
